import React from "react";

const FormHeader = ({
  title,
  subTitle,
  titleColor = "text-gray-900",
  subTitleColor = "text-gray-500",
}) => {
  return (
    <div className="text-center">
      <h2 className={`mt-6 text-center text-3xl font-extrabold ${titleColor}`}>
        {title}
      </h2>
      {subTitle && (
        <p className={`mt-2 text-center text-sm ${subTitleColor}`}>
          {subTitle}
        </p>
      )}
    </div>
  );
};

export default FormHeader;
